<div [@openClose]="starryNightOpen ? 'open' : 'closed'">
  <longmoon-atmosphere></longmoon-atmosphere>
  <longmoon-starfield></longmoon-starfield>
  <longmoon-constellation></longmoon-constellation>
  <longmoon-moon></longmoon-moon>
  <longmoon-terrain></longmoon-terrain>
</div>
